import { UnitConstants } from 'src/app/core/constants/unit';
import { ValidatorsTerms } from 'src/app/shared/validators/validators-terms';

const TERMS = ValidatorsTerms;

export class FlexLineGeneralFields {
  public static controls = {
    cofFileName: {
      quantity: null,
      validator: null,
    },
    cofData: {
      quantity: null,
      validator: null,
    },
    structure: {
      quantity: null,
      validator: null,
    },
    structureId: {
      quantity: null,
      validator: null,
    },
    lineSectionTag: {
      quantity: null,
      validator: null,
    },
    externalDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    internalDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    morisonInertia: {
      quantity: null,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    morisonDrag: {
      quantity: null,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    weightDry: {
      quantity: UnitConstants.QUANTITY.FORCE_BY_LENGTH,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    weightWet: {
      quantity: UnitConstants.QUANTITY.FORCE_BY_LENGTH,
      validator: null,
    },
    stiffAxial: {
      quantity: UnitConstants.QUANTITY.FORCE,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    stiffBending: {
      quantity: UnitConstants.QUANTITY.STIFFNESS_MODULUS,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    stiffTorsional: {
      quantity: UnitConstants.QUANTITY.STIFFNESS_MODULUS,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    hidrodynamicDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    capacityCurve: {
      quantity: null,
      validator: null,
    },

    // TODO: uncomment after issues solved
    // hysteresis: {
    //   quantity: null,
    //   validator: null,
    // },
    // preSlipBendingStiffness: {
    //   quantity: UnitConstants.QUANTITY.STIFFNESS_MODULUS,
    //   validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    // },
    // limitBendingMoment: {
    //   quantity: UnitConstants.QUANTITY.MOMENTUM,
    //   validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    // },
  };
}
